<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>Hibajelentés</ion-title>
    <ion-buttons slot="end" *ngIf="nezet !== 'uj'">
      <ion-button (click)="frissit()" [disabled]="frissul" title="Frissítés a hibakezelőből">
        <ion-spinner *ngIf="frissul" name="dots"></ion-spinner>
        <ion-icon *ngIf="!frissul" slot="start" name="refresh-outline"></ion-icon>
        Frissítés
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- ══ LISTA ═══════════════════════════════════════════════════════════ -->
  <ion-card *ngIf="nezet === 'lista'">
    <ion-card-header>
      <ion-card-title>{{ osszes ? 'Az intézmény bejelentései' : 'Bejelentéseim' }}</ion-card-title>
      <ion-card-subtitle>
        Hibát találtál, vagy kérdésed van a rendszerrel kapcsolatban? Írd meg itt – a bejelentés
        közvetlenül a fejlesztőkhöz kerül, és ha változik az állapota vagy válaszolnak rá, itt látod.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="hj-muvelet">
        <ion-button (click)="ujBejelentes()"><ion-icon slot="start" name="add-outline"></ion-icon>Új bejelentés</ion-button>
        <ion-button *ngIf="admin" fill="outline" (click)="osszesValt()">
          {{ osszes ? 'Csak a sajátjaim' : 'Összes jegy' }}
        </ion-button>
      </div>

      <div class="hj-allapot" *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner><span>Betöltés…</span></div>
      <div class="hj-allapot hiba" *ngIf="!toltodik && hiba">
        <ion-icon name="alert-circle-outline"></ion-icon><span>{{ hiba }}</span>
      </div>

      <ng-container *ngIf="!toltodik && !hiba">
        <div class="hj-ures" *ngIf="!jegyek.length">
          {{ osszes ? 'Az intézményből még nem érkezett bejelentés.' : 'Még nincs bejelentésed.' }}
        </div>
        <ion-list *ngIf="jegyek.length" lines="full">
          <ion-item *ngFor="let j of jegyek" button detail (click)="megnyit(j)">
            <ion-label>
              <h3 class="hj-targy">
                {{ j.targy }}
                <span class="hj-szam" *ngIf="j.redmine_id">#{{ j.redmine_id }}</span>
              </h3>
              <p>
                <span *ngIf="osszes">{{ j.bekuldo_nev }} · </span>
                <span *ngIf="j.kategoria">{{ kategoriaNev(j.kategoria) }} · </span>
                utolsó változás: {{ j.frissitve | date:'yyyy. MM. dd. HH:mm' }}
              </p>
            </ion-label>
            <ion-chip slot="end" [color]="allapotSzin(j)" class="hj-chip">{{ allapotNev(j) }}</ion-chip>
            <ion-badge slot="end" color="danger" *ngIf="j.olvasatlan">{{ j.olvasatlan }}</ion-badge>
          </ion-item>
        </ion-list>
      </ng-container>
    </ion-card-content>
  </ion-card>

  <!-- ══ ÚJ BEJELENTÉS ═══════════════════════════════════════════════════ -->
  <ion-card *ngIf="nezet === 'uj'">
    <ion-card-header>
      <ion-card-title>Új bejelentés</ion-card-title>
      <ion-card-subtitle>
        Írd le, mit csináltál, mit vártál, és mi történt helyette. A nevedet, az intézményt, a
        rendszer verzióját és azt, hogy melyik képernyőről jöttél, automatikusan hozzáadjuk.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="hj-urlap">
        <ion-input label="Tárgy *" label-placement="stacked" fill="outline" maxlength="200"
                   placeholder="pl. Nem menthető a hiányzás a 7.b naplójában" [(ngModel)]="uj.targy"></ion-input>
        <ion-select label="Kategória" label-placement="stacked" fill="outline" interface="popover"
                    placeholder="(nem kötelező)" [(ngModel)]="uj.kategoria">
          <ion-select-option value="">–</ion-select-option>
          <ion-select-option *ngFor="let k of kategoriak" [value]="k.kod">{{ k.nev }}</ion-select-option>
        </ion-select>
        <ion-textarea label="Leírás *" label-placement="stacked" fill="outline" [autoGrow]="true" rows="8"
                      maxlength="20000" [(ngModel)]="uj.leiras"
                      placeholder="Mit csináltál lépésről lépésre? Mi volt a hibaüzenet?"></ion-textarea>
        <div class="hj-fajl">
          <label>Melléklet (képernyőkép vagy PDF, legfeljebb 10 MB)</label>
          <input type="file" accept="image/png,image/jpeg,image/gif,image/webp,application/pdf"
                 (change)="fajlValaszt($event, 'uj')">
        </div>
        <ion-note color="medium" class="hj-honnan" *ngIf="honnan">Honnan jöttél: <b>{{ honnan }}</b></ion-note>
      </div>
      <div class="hj-muvelet">
        <ion-button (click)="bekuld()" [disabled]="!ujKuldheto">
          <ion-spinner *ngIf="kuld" name="dots"></ion-spinner>
          <ion-icon *ngIf="!kuld" slot="start" name="send-outline"></ion-icon>Beküldés
        </ion-button>
        <ion-button fill="clear" (click)="vissza()">Mégse</ion-button>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- ══ EGY JEGY ════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="nezet === 'jegy'">
    <div class="hj-allapot" *ngIf="toltodik && !jegy"><ion-spinner name="dots"></ion-spinner><span>Betöltés…</span></div>
    <ion-card *ngIf="!toltodik && hiba && !jegy">
      <ion-card-content>
        <div class="hj-allapot hiba"><ion-icon name="alert-circle-outline"></ion-icon><span>{{ hiba }}</span></div>
        <ion-button fill="clear" (click)="vissza()">Vissza a listához</ion-button>
      </ion-card-content>
    </ion-card>

    <ion-card *ngIf="jegy">
      <ion-card-header>
        <div class="hj-fej">
          <ion-button fill="clear" size="small" (click)="vissza()">
            <ion-icon slot="start" name="arrow-back-outline"></ion-icon>Lista
          </ion-button>
          <ion-chip [color]="allapotSzin(jegy)" class="hj-chip">{{ allapotNev(jegy) }}</ion-chip>
        </div>
        <ion-card-title>{{ jegy.targy }} <span class="hj-szam" *ngIf="jegy.redmine_id">#{{ jegy.redmine_id }}</span></ion-card-title>
        <ion-card-subtitle>
          {{ jegy.bekuldo_nev }}<span *ngIf="jegy.kontextus?.szerep"> ({{ jegy.kontextus.szerep }})</span>
          · {{ jegy.letrehozva | date:'yyyy. MM. dd. HH:mm' }}
          <span *ngIf="jegy.kategoria"> · {{ kategoriaNev(jegy.kategoria) }}</span>
        </ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <ion-note color="warning" class="hj-figy" *ngIf="jegy.kuldes_allapot !== 'elkuldve'">
          A bejelentést elmentettük, de a továbbítása még nem sikerült – a rendszer automatikusan újrapróbálja,
          neked nincs teendőd.
        </ion-note>

        <div class="hj-idovonal">
          <!-- Az eredeti bejelentés -->
          <div class="hj-elem sajat">
            <div class="hj-elem-fej"><b>{{ jegy.bekuldo_nev }}</b> · bejelentés
              <span class="hj-ido">{{ jegy.letrehozva | date:'yyyy. MM. dd. HH:mm' }}</span></div>
            <div class="hj-szoveg">{{ jegy.leiras }}</div>
            <div class="hj-mellekletek" *ngIf="csatolmanyok.length">
              <ion-chip *ngFor="let c of csatolmanyok" (click)="melleklet(c)" outline>
                <ion-icon name="attach-outline"></ion-icon><ion-label>{{ c.fajlnev }} <small>{{ meret(c.meret) }}</small></ion-label>
              </ion-chip>
            </div>
          </div>

          <div class="hj-elem" *ngFor="let e of esemenyek"
               [class.sajat]="e.sajat" [class.uj]="e.uj" [class.allapot]="e.tipus === 'allapot'">
            <div class="hj-elem-fej">
              <b>{{ e.szerzo || 'Ügyfélszolgálat' }}</b>
              <ng-container [ngSwitch]="e.tipus">
                <span *ngSwitchCase="'allapot'"> · állapot: <s *ngIf="e.regi_allapot">{{ e.regi_allapot }}</s> → <b>{{ e.uj_allapot }}</b></span>
                <span *ngSwitchCase="'valasz'"> · válasz</span>
                <span *ngSwitchCase="'csatolmany'"> · melléklet</span>
                <span *ngSwitchDefault> · megjegyzés</span>
              </ng-container>
              <span class="hj-uj" *ngIf="e.uj">új</span>
              <span class="hj-ido">{{ e.ideje | date:'yyyy. MM. dd. HH:mm' }}</span>
            </div>
            <div class="hj-szoveg" *ngIf="e.szoveg">{{ e.szoveg }}</div>
            <div class="hj-mellekletek" *ngIf="e.csatolmanyok?.length">
              <ion-chip *ngFor="let c of e.csatolmanyok" (click)="melleklet(c)" outline>
                <ion-icon name="attach-outline"></ion-icon><ion-label>{{ c.fajlnev }} <small>{{ meret(c.meret) }}</small></ion-label>
              </ion-chip>
            </div>
            <ion-note color="warning" *ngIf="e.fuggo" class="hj-kicsi">Továbbításra vár – a rendszer automatikusan elküldi.</ion-note>
          </div>
        </div>

        <div class="hj-valasz" *ngIf="!jegy.lezart || jog.admin">
          <ion-textarea label="Válasz" label-placement="stacked" fill="outline" [autoGrow]="true" rows="3"
                        maxlength="10000" [(ngModel)]="valasz"
                        placeholder="Kiegészítés, válasz a kérdésre…"></ion-textarea>
          <div class="hj-fajl">
            <label>Melléklet (nem kötelező)</label>
            <input type="file" accept="image/png,image/jpeg,image/gif,image/webp,application/pdf"
                   (change)="fajlValaszt($event, 'valasz')">
          </div>
          <ion-button (click)="valaszol()" [disabled]="!valaszKuldheto">
            <ion-spinner *ngIf="valaszKuld" name="dots"></ion-spinner>
            <ion-icon *ngIf="!valaszKuld" slot="start" name="send-outline"></ion-icon>Válasz küldése
          </ion-button>
        </div>
        <ion-note color="medium" class="hj-kicsi" *ngIf="jegy.lezart && !jog.admin">
          Ez a bejelentés le van zárva. Ha a hiba újra előjön, nyisd vissza, vagy küldj új bejelentést.
        </ion-note>
        <!-- Állapot: lezárás / visszanyitás innen is (a Redmine-ba is átmegy). -->
        <div class="hj-allapot-gombok" *ngIf="jegy.redmine_id">
          <ion-button *ngIf="!jegy.lezart" color="success" fill="outline" size="small" [disabled]="allapotFut" (click)="allapotValt('lezar')">
            <ion-icon slot="start" name="checkmark-done-outline"></ion-icon> Megoldva, lezárom
          </ion-button>
          <ion-button *ngIf="jegy.lezart" color="warning" fill="outline" size="small" [disabled]="allapotFut" (click)="allapotValt('visszanyit')">
            <ion-icon slot="start" name="refresh-outline"></ion-icon> Visszanyitás
          </ion-button>
        </div>
      </ion-card-content>
    </ion-card>
  </ng-container>
</ion-content>
